import { render, staticRenderFns } from "./uploadPayment.vue?vue&type=template&id=5a8b3055&scoped=true&"
import script from "./uploadPayment.vue?vue&type=script&lang=js&"
export * from "./uploadPayment.vue?vue&type=script&lang=js&"
import style0 from "./uploadPayment.vue?vue&type=style&index=0&id=5a8b3055&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b3055",
  null
  
)

export default component.exports